import React, { FC } from 'react';
import IPriceListDisplay from '../../interfaces/umbracoNodes/priceListDisplay';
import { Table, TableData, TableHeader, TableRow } from '../base/table/table';
import { P } from '../base/typography';
import AbnormalTable from './AbnormalTable';
import * as StyledPriceListDisplay from './priceListDisplay.styles';

interface Props {
	display: IPriceListDisplay;
}

const PriceListDisplay: FC<Props> = ({ display }) => {
	const nrOfColumns =
		(display.ShowName ? 1 : 0) +
		(display.ShowPrice ? 1 : 0) +
		(display.ShowPriceWithoutVAT ? 1 : 0) +
		(display.ShowThirdColumn ? 1 : 0) +
		(display.ShowFourthColumn ? 1 : 0) +
		(display.ShowFifthColumn ? 1 : 0) +
		(display.ShowSixthColumn ? 1 : 0);

	if (display.AbnormalTable) return <AbnormalTable display={display} nrOfColumns={nrOfColumns} />;

	return (
		<StyledPriceListDisplay.Wrapper>
			{display.Title.length > 0 && (
				<StyledPriceListDisplay.Heading>{display.Title}</StyledPriceListDisplay.Heading>
			)}
			<Table minWidth="40rem">
				<TableRow>
					{display.TableHeaders.map((header, index) => (
						<TableHeader key={index} mobile={1 / display.TableHeaders.length}>
							{header}
						</TableHeader>
					))}
				</TableRow>
				{display.Items.map((item, index) => (
					<TableRow key={index}>
						{display.ShowName && (
							<TableData mobile={1 / nrOfColumns}>
								<P>{item.Values.PageTitle}</P>
							</TableData>
						)}
						{display.ShowPrice && (
							<TableData mobile={1 / nrOfColumns}>
								<P>{item.Values.Price}</P>
							</TableData>
						)}
						{display.ShowPriceWithoutVAT && (
							<TableData mobile={1 / nrOfColumns}>
								<P>{item.Values.PriceWithoutVAT}</P>
							</TableData>
						)}
						{display.ShowThirdColumn && (
							<TableData mobile={1 / nrOfColumns}>
								<P>{item.Values.ThirdColumn}</P>
							</TableData>
						)}
						{display.ShowFourthColumn && (
							<TableData mobile={1 / nrOfColumns}>
								<P>{item.Values.FourthColumn}</P>
							</TableData>
						)}
					</TableRow>
				))}
			</Table>
		</StyledPriceListDisplay.Wrapper>
	);
};

export default PriceListDisplay;
